export function initTips() {
  $('.tips_mr_lnk').bind('click', e => {
    e.preventDefault();
    $($(this).attr('href')).toggle();
  });
}
